import { atom } from 'recoil';

export const driverComplaintState = atom({
  key: 'driver_complaint_state',
  default: {
    items: [],
    desc: null,
    order_by: null,
    total: null,
    size: 20,
    page: 1,
    screen: null,
    search_text: '',
    complaint_status: '',
  },
});

export const selectedComplaintState = atom({
  key: 'selected_complaint_state',
  default: {
    id: null,
    driver_id: null,
    user_id: null,
    status: null,
    created_ts: null,
    updated_ts: null,
    reason: null,
    name: null,
    phone_number: null,
    email: null,
    termination_id: null,
    user_name: null,
    driver_name: null,
    driver_email: null,
    driver_logo: null,
    termination_type: null,
    termination_reason: null,
    termination_category: null,
    termination_status: null,
  },
});
